<template>
  <div>
    <el-form
      class="query-form"
      :style="noBg ? 'background:transparent' : ''"
      ref="refForm"
      :model="searchData"
      :size="size"
      :inline="inline"
      :label-width="labelWidth"
      v-bind="$attrs"
      label-position="right"
      v-on="$listeners">
      <el-form-item
        v-for="item in formInfo"
        :label="item.label"
        :key="item.prop"
        :prop="item.prop"
        class="form_item"
        :class="{
          'long-form': longTypeArr.includes(item.type),
          nobtm: removeBottom,
        }"
        :style="item.style"
        v-if="
          (item.permissions ? getPermissions(item.permissions) : !item.notShow) && item.isHide != true
        ">
        <!-- 自定义 -->
        <template #label v-if="item.slotLabel">
          <slot :name="item.slotLabel" :scope="item"></slot>
        </template>
        <template>
          <div v-if="item.slot">
            <slot :name="item.slot" :scope="item" :form="searchData"></slot>
          </div>
          <div v-if="item.slotError">
            <slot :name="item.slotError" :scope="item"></slot>
          </div>
          <!-- 输入框 -->
          <el-input
            :class="item.append ? 'ml4': ''"
            v-if="item.type === 'Input'"
            v-model="searchData[item.prop]"
            :style="{ width: item.width || width }"
            :placeholder="item.placeholder"
            @input="inputFun(item, $event)"
            @change="
              (val) =>
                item.change
                  ? item.change(val)
                  : () => {
                      return val;
                    }
            ">
              <template v-if="item.append" slot="suffix">{{ item.append }}</template>
            </el-input>
          <!-- 联级选择器 -->
          <el-cascader
            v-else-if="item.type === 'cascader'"
            v-model="searchData[item.prop]"
            :show-all-levels="false"
            collapse-tags
            :options="item.options"
            :props="item.props"
            style="width: 290px"></el-cascader>
          <!-- 双输入框 -->
          <template v-else-if="item.type === 'InputDouble'">
            <div :style="{ width: item.width || width }" class="input_flex">
              <el-input
                v-model="searchData[item.startKey]"
                class="input_item"
                :placeholder="item.startPlaceholder"
                style="width: 145px"
                @input="inputFun(item, $event)"
                :type="item.inputType || 'text'">
                <template v-if="item.startSuffix" slot="suffix">
                  <div class="suffixBody">
                    <span>{{ item.startSuffix }}</span>
                  </div>
                </template>
              </el-input>
              <span
                style="margin: 0 4px; line-height: 32px"
                class="time-span-text"
                >至</span
              >
              <el-input
                v-model="searchData[item.endKey]"
                class="input_item"
                :placeholder="item.endPlaceholder"
                style="width: 145px"
                @input="inputFun(item, $event)"
                :type="item.inputType || 'text'">
                <template v-if="item.endSuffix" slot="suffix">
                  <div class="suffixBody">
                    <span>{{ item.endSuffix }}</span>
                  </div>
                </template>
              </el-input>
            </div>
          </template>
          <!-- 下拉框 -->
          <el-select
            v-else-if="item.type === 'Select'"
            v-model="searchData[item.prop]"
            :multiple="item.multiple ? true : false"
            :collapse-tags="item.multiple ? true : false"
            :disabled="item.disabled"
            :style="{ width: item.width || width }"
            @change="(e) => selectChange(e, item.prop)">
            <el-option
              v-for="op in item.options"
              :label="op.label"
              :value="op.value"
              :key="op.value"></el-option>
          </el-select>
          <!-- 级联选择器 -->
          <el-cascader
            v-else-if="item.type === 'cascadeSelect'"
            v-model="searchData[item.prop]"
            :show-all-levels="item.showAllLevels ? true : false"
            collapse-tags
            :options="item.options"
            :props="{
              multiple: item.multiple,
              expandTrigger: 'click',
              emitPath: false,
            }"
          ></el-cascader>
          <!-- 单选 -->
          <el-radio-group
            v-else-if="item.type === 'Radio'"
            v-model="searchData[item.prop]"
            :style="{ width: item.width || width }">
            <el-radio
              v-for="ra in item.options"
              :label="ra.value"
              :key="ra.value"
              :style="{ width: ra.width || 'auto' }"
              >{{ ra.label }}</el-radio
            >
          </el-radio-group>
          <!-- 单选按钮 -->
          <el-radio-group
            v-else-if="item.type === 'RadioButton'"
            v-model="searchData[item.prop]">
            <el-radio-button
              v-for="ra in item.options"
              :label="ra.value"
              :key="ra.value"
              >{{ ra.label }}</el-radio-button
            >
          </el-radio-group>
          <!-- 复选框 -->
          <el-checkbox-group
            v-else-if="item.type === 'Checkbox'"
            v-model="searchData[item.prop]">
            <el-checkbox v-if="item.all" label="不限" value=""></el-checkbox>
            <el-checkbox
              v-for="ch in item.options"
              :label="ch.value"
              :key="ch.value"
              >{{ ch.label }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- 日期范围 -->
          <time-pick
            v-else-if="item.type === 'DateRange'"
            :disabled="item.disabled"
            :type="item.dateType"
            :style="{ width: item.width || width }"
            :startTime.sync="searchData[item.startKey]"
            :endTime.sync="searchData[item.endKey]"
            :format="item.format"
            :clearable="item.clearable"
            :defaultValueStart="item.defaultValueStart"
            :defaultValueEnd="item.defaultValueEnd"
            :pickerOptionsStart="item.pickerOptionsStart"
            :pickerOptionsEnd="item.pickerOptionsEnd"
            :defalutLimit="item.defalutLimit"
            @change="
              (time) => changeDate(time.startTime, time.endTime, item)
            "></time-pick>
          <!-- 单选+自定义 -->
          <el-radio-group
            v-else-if="item.type === 'RadioCustom'"
            v-model="searchData[item.prop]">
            <template v-for="ra in item.options">
              <el-radio :label="ra.value">
                {{ ra.label }}
              </el-radio>
              <template v-if="ra.custom">
                <el-input
                  class="short-input"
                  size="small"
                  v-model="searchData[ra.startKey]"
                  type="text"
                  style="width: 120px"
                  :disabled="searchData[item.prop] != ra.value">
                  <span slot="suffix">{{ ra.unit }}</span>
                </el-input>
                <span
                  style="display: inline-block; margin: 0 4px; font-size: 12px"
                  class="time-span-text"
                  >至</span
                >
                <el-input
                  class="short-input"
                  size="small"
                  v-model="searchData[ra.endKey]"
                  type="number"
                  style="width: 120px"
                  :disabled="searchData[item.prop] != ra.value">
                  <span slot="suffix">{{ ra.unit }}</span>
                </el-input>
              </template>
            </template>
          </el-radio-group>
          <!-- 单选+自定义日期范围 -->
          <el-radio-group
            style="display: flex; align-items: center"
            v-else-if="item.type === 'RadioCustomDate'"
            v-model="searchData[item.prop]"
            @input="radioTime($event, item)">
            <template v-for="ra in item.options">
              <el-radio :label="ra.value" style="margin-top: 3px">
                {{ ra.label }}
              </el-radio>
              <template v-if="ra.custom">
                <time-pick
                  :type="ra.dateType"
                  :style="{ width: ra.width || width }"
                  :startTime.sync="searchData[ra.startKey]"
                  :endTime.sync="searchData[ra.endKey]"
                  :format="ra.format"
                  :clearable="ra.clearable"
                  :defaultValueStart="ra.defaultValueStart"
                  :defaultValueEnd="ra.defaultValueEnd"
                  :pickerOptionsStart="ra.pickerOptionsStart"
                  :pickerOptionsEnd="ra.pickerOptionsEnd"
                  :defalutLimit="ra.defalutLimit"
                  :disabled="searchData[item.prop] != ra.value && item.disabled"
                  @change="
                    (time) => changeDate(time.startTime, time.endTime, ra)
                  "></time-pick>
              </template>
            </template>
          </el-radio-group>
          <!-- 单选+自定义日期范围 -->
          <div
            v-else-if="item.type === 'btnCustomDate'"
            style="display: flex; align-items: center">
            <radioBtn
              :recentList="item.options"
              :value.sync="searchData[item.prop]"
              @change="radioTime($event, item)"></radioBtn>
            <template v-for="(ra, index) in item.options">
              <time-pick
                :key="index"
                v-if="ra.custom"
                :type="ra.dateType"
                :style="{ width: ra.width || width }"
                :startTime.sync="searchData[ra.startKey]"
                :endTime.sync="searchData[ra.endKey]"
                :format="ra.format"
                :clearable="ra.clearable"
                :defaultValueStart="ra.defaultValueStart"
                :defaultValueEnd="ra.defaultValueEnd"
                :pickerOptionsStart="ra.pickerOptionsStart"
                :pickerOptionsEnd="ra.pickerOptionsEnd"
                :defalutLimit="ra.defalutLimit"
                :disabled="searchData[item.prop] != ra.value && item.disabled"
                @change="
                  (time) => changeDate(time.startTime, time.endTime, ra)
                "></time-pick>
            </template>
          </div>
          <!-- 下拉框+自定义日期范围 -->
          <selectCustomDate
            v-else-if="item.type === 'SelectCustomDate'"
            :style="{ width: item.width || width }"
            :startTime.sync="searchData[item.startKey]"
            :endTime.sync="searchData[item.endKey]"
            :baseDate="item.baseDate"
            :ref="item.startKey"
            :type="item.timeType">
          </selectCustomDate>
          <!-- 下拉框+自定义日期范围 -->
          <selectCustomDate
            v-else-if="item.type === 'SelectCustomDate2'"
            :style="{ width: item.width || width }"
            :startTime.sync="searchData[item.startKey]"
            :endTime.sync="searchData[item.endKey]"
            :baseDate="item.baseDate"
            :baseDateStart="item.baseDateStart"
            :baseDateEnd="item.baseDateEnd"
            :yesterday="item.yesterday"
            :baseType="item.baseType"
            :ref="item.startKey">
          </selectCustomDate>
          <!-- 单选+选择商品 -->
          <!-- 选择地区 -->
          <el-radio-group
            v-else-if="item.type === 'City'"
            v-model="searchData[item.prop]">
            <template v-for="ra in cityOptions">
              <el-radio :label="ra.value">
                {{ ra.label }}
              </el-radio>
            </template>
            <template>
              <jd-button
                @click="handeSelectCity"
                v-if="searchData[item.customKey]"
                v-show="searchData[item.prop] == 3"
                :disabled="searchData[item.prop] != 3"
                type="select">
                已选<span>{{ searchData[item.customKey].length }}</span
                >个
              </jd-button>
              <city-popover
                v-model="cityVisible"
                :checkedList="searchData[item.customKey]"
                @on-change="
                  (arr) => (
                    (searchData[item.customKey] = arr), (cityVisible = false)
                  )
                "
                @close="cityVisible = false"></city-popover>
            </template>
          </el-radio-group>
          <!-- 选择地区 -->
          <div v-else-if="item.type === 'City1'">
            <jd-select
             :num="searchData[item.customKey]?searchData[item.customKey].length:0"
             btnText="选择地区"
             @bin="cityVisible = true"></jd-select>
            <city-popover
              v-model="cityVisible"
              :hideMunicipalityChildren="hideMunicipalityChildren"
              :checkedList="searchData[item.customKey]"
              @on-change="
                (arr) => (
                  (searchData[item.customKey] = arr), (cityVisible = false)
                )
              "
              @close="cityVisible = false"></city-popover>
          </div>
          <!-- 选择商品 -->
          <input-goods
            v-else-if="item.type === 'InputGoods'"
            :isNeedSku="item.isNeedSku ? item.isNeedSku : false"
            :style="{ width: item.width || width }"
            v-model="searchData[item.prop]"
            @changeSku="handleSkuChange"></input-goods>
          <!-- 开关 -->
          <el-switch
            v-else-if="item.type === 'Switch'"
            v-model="searchData[item.prop]"></el-switch>
        </template>
      </el-form-item>
      <el-form-item v-if="btn30">
        <div>
          <jd-button
            type="blue"
            :disabled="handleSearchDisabled"
            v-if="handleSearchShow"
            @click="handleSearch"
            >{{ handleSearchText }}</jd-button
          >
          <jd-button
            :disabled="handleResetDisabled"
            v-if="!noReset"
            @click="handleReset"
            >{{ handleResetText }}</jd-button
          >
        </div>
      </el-form-item>
      <el-form-item v-else :style="handleStyle">
        <div slot="label">
          <!-- 展开收起按钮 -->
          <template v-if="showExpandButton && isNeedToggle">
            <div @click="toggleExpand" class="btn-one2 btn-one_more2">
              <span
                style="cursor: pointer; margin-right: 4px"
                class="theme_color"
                >{{ isExpanded ? "收起" : "展开" }}</span
              >
              <i
                :class="
                  isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "></i>
            </div>
          </template>
        </div>
        <div :style="{ marginLeft: showExpandButton ? '' : '' }">
          <jd-button
            type="blue"
            :disabled="handleSearchDisabled"
            v-if="handleSearchShow"
            @click="handleSearch"
            >{{ handleSearchText }}</jd-button
          >
          <jd-button
            :disabled="handleResetDisabled"
            v-if="!noReset"
            @click="handleReset"
            >{{ handleResetText }}</jd-button
          >
        </div>
      </el-form-item>
      <!-- 添加特殊时间 -->
      <template
        style="display: inline-block; margin-top: -10px; width: 350px"
        v-if="showTrue == '1'">
        <span v-if="show == '1'">
          <br />
        </span>
        <span style="margin-top: 10px; color: #666; margin-left: 30px"
          >下单时间:</span
        >
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="analyzeForm.startTime"
          type="datetime"
          placeholder="选择日期时间"
          size="small"
          style="margin-left: 10px; width: 145px">
        </el-date-picker>
        <span style="margin-left: 8px; margin-right: 8px" class="time-span-text"
          >至</span
        >
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="analyzeForm.endTime"
          type="datetime"
          placeholder="选择日期时间"
          size="small"
          style="width: 145px"></el-date-picker>
      </template>
      <!-- end -->
      <!-- 按钮 -->
      <div
        class="button-box"
        :style="{
          left: btnLeft ? btnLeft : '',
          bottom: btnBottom ? btnBottom : '',
          top: btnTop ? btnTop : '',
        }"
        v-if="customBtnList.length > 0">
        <template>
          <div v-for="(item, index) in customBtnList" :key="index">
            <div>
              <jd-button
                :type="item.type"
                :size="item.size || size"
                @click="handleBtn(item)"
                >{{ item.label }}</jd-button
              >
            </div>
          </div>
        </template>
      </div>

      <!-- 额外的按钮 -->
      <slot name="buttonOut" :formData="searchData"></slot>
    </el-form>
  </div>
</template>

<script>
/** formInfo
 * prop  表单域 model 字段
 * label 标签文本
 * placeholder 占位文本
 * disabled 禁用
 * type  类型 Input Select Radio RadioButton Checkbox Switch Time Date
 * width 宽度
 * value 默认值
 * size  尺寸
 * slot  插槽名称
 * slotLabel 表单标签插槽名称（不要和slot名称重复）
 * slotError 表单校验信息插槽名称，参数为 { error }
 * change  选中值发生变化时触发
 *
 * 部分类型独有配置
 * ( Input )
 * maxlength 最大输入长度
 * show-word-limit 是否显示输入字数统计
 * ( Select Radio RadioButton )
 * options 选项组
 *
 * ( InputDouble )
 * startKey 起始key
 * endKey   结尾key
 * startValue 起始默认值
 * endValue   结尾默认值
 * startPlaceholder 起始提示文本
 * endPlaceholder   结尾提示文本
 *
 * ( DateRange ) 详情参考timePick组件说明
 * startKey: 开始时间绑定的key
 * endKey: 结束时间绑定的key
 * dateType: 时间组件的类型 默认 date
 * format 时间格式 datetime默认为"yyyy-MM-dd HH:mm:ss" date默认为"yyyy-MM-dd"
 * defaultValueStart  开始时间的default-value;  defaultValueEnd 结束时间的default-value
 * lastDay: 默认近几天
 *
 * （SelectCustomDate）下拉框+自定义时间
 * startKey: 开始时间绑定的key
 * endKey: 结束时间绑定的key
 *
 * 说明： 因目前场景有限，暂固定选项为 '近7天''近15天''近30天''自定义',固定选中'近7天' 后续有需要再自行添加参数
 *
 * ( RadioCustom )独占一行组件
 * prop  表单域 model 字段
 * label 标签文本
 * value 默认值
 * options 选项组 [item]
 * item:{
 *   label:  文本
 *   value:  对应值
 *   custom: 是否添加自定义框 Boolean
 *   startKey: 自定义框起始字段  custom为true必传
 *   endKey:   自定义框结尾字段  custom为true必传
 *   unit: 自定义框单位
 *   startValue:自定义框起始默认值
 *   endValue:  自定义框结尾默认值
 *
 * ( City ) 独占一行组件
 * prop  表单域 model 字段
 * label 标签文本
 * value 默认值
 * customKey 自定义 城市数组key
 * customValue 自定义 城市默认数组 不传为[]
 *
 * }
 */
import timePick from "./timePick.vue";
import selectCustomDate from "./selectCustomDate.vue";
import cityPopover from "@/components/city-popover-x.vue";
import inputGoods from "./inputGoods.vue";
import radioBtn from "./radioBtn.vue";

export default {
  components: {
    timePick,
    cityPopover,
    inputGoods,
    selectCustomDate,
    radioBtn,
  },
  props: {
    show: null,
    showTrue: null,
    noBg: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: "auto",
    },
    width: {
      type: String,
      default: "290px",
    },
    size: {
      type: String,
      default: "small",
    },
    inline: {
      type: Boolean,
      default: true,
    },
    formInfo: {
      type: Array,
      default: () => [],
    },
    // 自定义按钮列表
    customBtnList: {
      type: Array,
      default: () => [],
    },
    // 是否关闭重置按钮
    noReset: {
      type: Boolean,
      default: false,
    },
    // 是否立即触发
    immediately: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //查询区位置
    btnLeft: {
      type: String,
      default: "1350px",
    },
    btnTop: {
      type: String,
      default: null,
    },
    btnBottom: {
      type: String,
      default: null,
    },
    // 移除底部18px外边距 为不影响原有效果 默认为false
    removeBottom: {
      type: Boolean,
      default: false,
    },
    // 重置按钮自定义事件
    emitReset: {
      type: Boolean,
      default: false,
    },
    // 重置按钮是否重置数据
    isreData: {
      type: Boolean,
      default: false,
    },
    // 查询按钮文字
    handleSearchText: {
      type: String,
      default: "查询",
    },
    //重置按钮文字
    handleResetText: {
      type: String,
      default: "重置",
    },
    // 查询按钮禁用
    handleSearchDisabled: {
      type: Boolean,
      default: false,
    },
    // 重置按钮禁用
    handleResetDisabled: {
      type: Boolean,
      default: false,
    },
    // 是否显示查询按钮
    handleSearchShow: {
      type: Boolean,
      default: true,
    },
    // 是否按钮只和最后一项距离30px
    btn30: {
      type: Boolean,
      default: false,
    },
    // 删除空字段
    deleteNull: {
      type: Boolean,
      default: false,
    },
    isNeedToggle: {
      // 是否需要展开收起操作
      type: Boolean,
      default: false,
    },
    handleStyle: Object, // 自定义操作区域样式
    hideMunicipalityChildren: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   requestAnimationFrame(() => {
    //     this.internalLabelWidth = this.labelWidth;
    //   });
    // });
    this.$nextTick(() => {
      // 计算行数
      let rowCount = this.calculateRowCount();
      this.showExpandButton = rowCount > 2;
    });
    //处理客户分析节点--此逻辑后续需优化
    if (this.showTrue == 1) {
      sessionStorage.setItem("isTime", this.formData.tradeCreateStartTime);
      sessionStorage.setItem("isTime1", this.formData.tradeCreateEndTime);
      this.analyzeForm.startTime = this.formData.tradeCreateStartTime;
      this.analyzeForm.endTime = this.formData.tradeCreateEndTime;
    }
    //end
    // let obj = this.getInitForm();
    // Object.keys(obj).forEach((item) => {
    //   this.$set(this.searchData, item, obj[item]);
    // });
    this.reData();
    if (this.immediately) {
      this.handleSearch();
    }
  },
  watch: {},
  data() {
    return {
      internalLabelWidth:"",
      isSku: false,
      value1: "",
      analyzeForm: {
        startTime: "",
        endTime: "",
      },
      searchData: {},
      longTypeArr: ["RadioCustom", "City"],
      cityOptions: [
        { label: "不限", value: "" },
        { label: "江浙沪", value: 1 },
        { label: "偏远地区", value: 2 },
        { label: "自定义", value: 3 },
      ],
      // 选择地区
      cityVisible: false,
      // 选择商品
      goodsVisible: false,
      isExpanded: false, // 展开状态
      showExpandButton: false, // 是否显示展开按钮
    };
  },
  computed: {
    // 计算显示的表单项
    displayFormInfo() {
      if (this.showExpandButton && !this.isExpanded) {
        // 未展开时显示前两行
        let count = 0;
        let result = [];
        for (let item of this.formInfo) {
          if (count >= 2) break;
          result.push(item);
          if (this.isNewRow(item)) count++;
        }
        return result;
      }
      return this.formInfo;
    },
  },
  methods: {
    inputFun(item, val) {
      if (item.input) {
        return item.input(val,this.searchData);
      } else {
        if (item.isNumber) {
          // 只能输入数字
          let value = val.replace(/^\.+|[^\d.]/g, "");
          this.$set(this.searchData, item.prop, value);
          return value;
        }
        return val;
      }
    },
    // 计算权限位
    getPermissions(str) {
      const permissions = JSON.parse(
        sessionStorage.getItem("sellerPlatform")
      ).permissions;
      return permissions.includes(str);
    },
    // 手动重置数据 用于给父组件ref调用及减少重复代码
    reData() {
      let obj = this.getInitForm();
      Object.keys(obj).forEach((item) => {
        this.$set(this.searchData, item, obj[item]);
      });
    },
    handleSkuChange(val) {
      this.isSku = val;
    },
    // 抛出选择器选中事件
    selectChange(e, key) {
      this.$emit("selectChange", {
        key, //当前选择器的key
        val: e, //选中的val
      });
      this.$forceUpdate();
    },
    handleSearch() {
      this.$emit("update:formData", { ...this.formData, ...this.searchData });
      let params = { ...this.searchData };
      if (this.isSku) {
        params.isSku = this.isSku;
      }
      this.$emit("search", params);
      sessionStorage.setItem('exportForm',JSON.stringify(params))
      //处理客户分析节点--此逻辑后续需优化
      if (this.showTrue == 1) {
        this.$emit("customer", this.analyzeForm);
        this.$emit("customer1", this.analyzeForm);
        this.$emit("customer2", this.analyzeForm);
      }
      //end
    },
    handleReset() {
      // 自定义事件后不重置
      if (!this.emitReset || this.isreData) {
        // let obj = this.getInitForm();
        // Object.keys(obj).forEach((item) => {
        //   this.searchData[item] = obj[item];
        // });
        this.reData();
      }
      //end
      setTimeout(() => {
        this.$emit("update:formData", { ...this.formData, ...this.searchData });
        // 兼容使用插槽,表单无法重置问题
        // if (this.emitReset) {
        //   this.$emit("reset", this.searchData);
        // } else {
        //   this.$emit("search", this.searchData);
        // }
        this.$emit(this.emitReset ? "reset" : "search", this.searchData , true);
      }, 500);
      //处理客户分析节点--此逻辑后续需优化
      if (this.showTrue == 1) {
        let strong = sessionStorage.getItem("isTime");
        let strong1 = sessionStorage.getItem("isTime1");
        this.analyzeForm.startTime = strong;
        this.analyzeForm.endTime = strong1;
        this.$emit("customer", this.analyzeForm);
        this.$emit("customer1", this.analyzeForm);
        this.$emit("customer2", this.analyzeForm);
      }
    },
    handleBtn(item) {
      this.$emit(item.handle, this.searchData);
    },
    setFormData(data) {
      // 设置表单数据，用于初始化表单
      this.searchData = { ...this.searchData, ...data };
    },
    getSearchForm() {
      return this.searchData;
    },
    changeDate(start, end, item) {
      console.log(start, end, item);
      this.$set(this.searchData, item.startKey, start);
      this.$set(this.searchData, item.endKey, end);
      this.$forceUpdate();
      this.$emit("changeDate", start, end, item);
    },
    radioTime(val, item) {
      if (item.noShowTime) return;
      let day, tiemArr, tiemObj;
      tiemArr = item.options.filter((item) => {
        if (item.value == val && !item.custom) {
          day = item.day;
        }
        return item.custom;
      });
      if (tiemArr.length > 0) {
        tiemObj = tiemArr[0];
      }
      if(val == 99) {
        // 指定时间段
        const time = item.options.find((item) => item.value == 99);
        if(time) {
          this.searchData[tiemObj.startKey] = time.startTime;
          this.searchData[tiemObj.endKey] = time.endTime;
        }
        return;
      }
      // 自定义开始时间
      if(day && item.defaultStartDate) {
        this.searchData[tiemObj.startKey] = this.moment(item.defaultStartDate).format("YYYY-MM-DD HH:mm:ss");
        this.searchData[tiemObj.endKey] = this.moment(item.defaultStartDate).add(day - 1, 'days').format("YYYY-MM-DD") + " 23:59:59";
      }else if (day) {
        this.searchData[tiemObj.startKey] = this.getDateStr(-day) + " 00:00:00";
        this.searchData[tiemObj.endKey] = this.getDateStr(0) + " 23:59:59";
      } else {
        this.searchData[tiemObj.startKey] = "";
        this.searchData[tiemObj.endKey] = "";
      }
    },
    // 判断是不是undefined
    isUndefined(val) {
      if (val == undefined) return null;
      else return val;
    },

    // 获取初始化对象
    getInitForm() {
      // this.$refs.refForm.resetFields();
      let formObj = {};
      this.formInfo.map((item) => {
        if (item.type == "DateRange") {
          if (!!item.lastDay || item.lastDay === 0) {
            formObj[item.startKey] = this.getLastTime(item.lastDay);
            if (item.noEndTime) {
              formObj[item.endKey] = null;
            } else {
              formObj[item.endKey] = this.getLastTime(0);
            }
          } else {
            formObj[item.startKey] = this.isUndefined(item.startTime);
            formObj[item.endKey] = this.isUndefined(item.endTime);
          }
        } else if (item.type == "SelectCustomDate") {
          console.log(this.$refs[item.startKey]);
          this.$refs[item.startKey][0].handleChange(7);
          // formObj[item.startKey] = this.getLastTime(7);
          // formObj[item.endKey] = this.getLastTime(0);
        } else if (item.type == "SelectCustomDate2") {
          console.log(this.$refs[item.startKey]);
          this.$refs[item.startKey][0].handleChange(item.baseType);
        } else if (item.type == "InputDouble") {
          formObj[item.startKey] = this.isUndefined(item.startValue);
          formObj[item.endKey] = this.isUndefined(item.endValue);
        } else if (item.type == "RadioCustom") {
          formObj[item.prop] = this.isUndefined(item.value);
          item.options &&
            item.options.forEach((ra) => {
              if (ra.custom) {
                formObj[ra.startKey] = this.isUndefined(ra.startValue);
                formObj[ra.endKey] = this.isUndefined(ra.endValue);
              }
            });
        } else if (item.type == "City") {
          formObj[item.prop] = this.isUndefined(item.value);
          formObj[item.customKey] = item.customValue || [];
        } else if (item.type == "City1") {
          formObj[item.customKey] = item.customValue || [];
        } else if (item.type == "RadioCustomDate" && !item.noShowTime) {
          formObj[item.prop] = this.isUndefined(item.value);
          this.radioTime(item.value, item);
        } else if (item.type == "btnCustomDate" && !item.noShowTime) {
          formObj[item.prop] = this.isUndefined(item.value);
          this.radioTime(item.value, item);
        } else {
          formObj[item.prop] = this.isUndefined(item.value);
        }
      });
      sessionStorage.setItem('exportForm',JSON.stringify(formObj))
      return { ...formObj };
    },
    // 获取最近 last 天时间 格式 yyyy-mm-dd
    getLastTime(last) {
      let count = Number(last);
      const date = new Date(Date.now() - count * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      console.log("last", date, `${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    },
    // 选择地区弹窗
    handeSelectCity(item) {
      this.cityVisible = true;
    },
    // 切换展开状态
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      console.log("this.isExpanded", this.isExpanded);
      this.$emit("toggleExpand", this.isExpanded);
    },
    // 计算行数
    calculateRowCount() {
      let count = 1;
      let lastBottom = 0;
      const formItems = this.$el.querySelectorAll(".form_item");
      formItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.top > lastBottom) {
          count++;
          lastBottom = rect.bottom;
        }
      });
      return count;
    },
    // 判断是否新行
    isNewRow(item) {
      return item.type === "RadioCustom" || item.type === "City";
    },
    // 导出
    export_fun() {
      if (this.deleteNull) {
        let params = JSON.parse(JSON.stringify({ ...this.formData, ...this.searchData }));
        for (var i in params) {
          if (params[i] + "" == "") {
            delete params[i];
          }
        }
        console.log("export_get", params);
        this.$emit("export_get", params);
      } else {
        console.log("export_get", { ...this.formData, ...this.searchData });
        this.$emit("export_get", { ...this.formData, ...this.searchData });
      }
    },
    // 返回当前查询参数
    export_fun2(){
      let params = JSON.parse(JSON.stringify({ ...this.formData, ...this.searchData }));
      return params
    },
    export_fun() {
      this.$emit("export_get", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.time-span-text{
  font-size: $main-size;
  color: #666666;
}
.button-box {
  position: absolute;
  bottom: 16px;
}
.query-form {
  position: relative;
  background: #f8f9fa;
  padding: 16px 16px 0 16px;
  box-sizing: border-box;
  border-radius: 4px 4px 4px 4px;
}
.nobtm {
  margin-bottom: 0;
}
.form_item {
  margin-right: 30px !important;
  margin-bottom: 16px !important;
}

.input_flex {
  display: flex;
  align-items: center;
}

.long-form .el-form-item {
  display: flex;
  width: 100% !important;
  align-items: flex-start;
  .el-form-item__label {
    // width: 100px;
    padding: 0;
  }
  .el-form-item__content {
    flex: 1;
    // width: auto;
    .el-input__suffix {
      line-height: 32px;
    }
  }
  .el-form-item__content > :first-child {
    width: 100%;
  }
}
/deep/ .el-form-item__label {
  padding: 0 0 0 12px !important;
  font-weight: 400;
  font-size: 14px !important;
  color: #4C4C4C !important;
  min-width: 84px;
}
.suffixBody {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  height: 100%;
  padding: 0 12px;
  border-left: 1px solid rgba(236, 236, 236, 1);
}
::v-deep .el-input .el-input__inner {
  font-size: $main-size !important;
}
::v-deep .el-input--small .el-input__icon {
  width: $secondary-size !important;
}
::v-deep .el-date-editor .el-input__inner{
  // font-size: $secondary-size !important;
  font-family: PingFang SC;
}
::v-deep .el-input .el-input__suffix-inner {
  color: #333333;
  font-size: 14px;
}
.btn-one2 {
  width: 56px;
  height: 32px;
  opacity: 1;
  font-size: $main-size;
  font-weight: 400;
  line-height: 32px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
.btn-one_more2 {
  height: 32px;
  font-size: $main-size;
  font-weight: 400;
  line-height: 30px;
  color: #3159ff;
}
</style>
